import Swal from 'sweetalert2'
import "./Contact.css"

import {
    FaEnvelope,
    FaInstagram,
    FaPhone,
    FaTiktok,
    FaYoutube
} from 'react-icons/fa';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";


function Contact() {
    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        formData.append("access_key", "17950dbf-8123-4f5a-abda-2a52318a1cf7");

        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        const res = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
            },
            body: json
        }).then((res) => res.json());

        if (res.success) {
            Swal.fire({
                title: "Success!",
                text: "Message sent successfully!",
                icon: "success"
              });
        }
    };

    return (
        <section id="contact" className="contact">
            <div className='contact-information-section'>
                <div className='pickup-information'>
                    <h2>Pick-Up Information</h2>
                    <div className="pickup-item">
                        <FaMapMarkerAlt className="pickup-icon" />
                        <span>Kearny Mesa. San Diego. 92111.</span>
                    </div>

                    <div className="pickup-item">
                        <FaClock className="pickup-icon" />
                        <span>Every Sunday | 9:00 AM – 11:00 AM</span>
                    </div>
                </div>
                <div className="contact-information">
                    <h2>Business Inquiries</h2>
                    <a 
                        href="mailto:jackyjdam@gmail.com" 
                        target="_blank" 
                        className="contact-field"
                    >
                        <FaEnvelope className="contact-icon contact-item" aria-label="Email" />
                        <span className="contact-item">jackyjdam@gmail.com</span>
                    </a>

                    <a 
                        target="_blank" 
                        className="contact-field"
                    >
                        <FaPhone className="contact-icon contact-item" aria-label="Phone" />
                        <span className="contact-item">+1 (619) 354-0990</span>
                    </a>
                </div>

                <div className='social-information'>
                    <h2>Social Media</h2>
                    <a href="https://www.youtube.com/@jdskitchenbakes/?utm_source=jdskitchen&utm_medium=contact_form&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                        <FaYoutube className='contact-social contact-icon' aria-label='Youtube'/>
                    </a>

                    <a href="https://www.instagram.com/jdskitchenbakes/?utm_source=jdskitchen&utm_medium=contact_form&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className='contact-social contact-icon' aria-label='Instagram'/>
                    </a>

                    <a href="https://www.tiktok.com/@jdskitchenbakes/?utm_source=jdskitchen&utm_medium=contact_form&utm_campaign=social_links" target="_blank" rel="noopener noreferrer">
                        <FaTiktok className='contact-social contact-icon' aria-label='Tiktok'/>
                    </a>
                </div>

            </div>

            <form className='contact-form' onSubmit={onSubmit}>
                <h2>Send a Message</h2>
                <div className="input-box">
                    <label>Full Name</label>
                    <input type="text" className="field" name='name' required />
                </div>
                <div className="input-box">
                    <label>Email Address</label>
                    <input type="email" className="field" name='email' required />
                </div>
                <div className="input-box">
                    <label>Message</label>
                    <textarea name='message' className="field message" required ></textarea>
                </div>
                <button className='button-74' type="submit">Submit</button>
            </form>
        </section>
    );
}

export default Contact;